import {type LexiconDoc} from '@atproto/lexicon'

/**
 * The For-you feed's ears.
 *
 * A procedure whose input is the batch of sightings and signals a session has
 * collected since the last flush (`#/state/feed-ranking`). Registered here, not
 * in the SDK, because it is ours: `agent.call` looks the method up in the
 * agent's own lexicon set, and the shape is checked at the far end — the AppView
 * validates the body against the real record before anything is written, so the
 * copy here stays the smallest thing that makes the call possible.
 */
export const recordFeedEvents: LexiconDoc = {
  lexicon: 1,
  id: 'app.taderok.feed.recordEvents',
  defs: {
    main: {
      type: 'procedure',
      input: {
        encoding: 'application/json',
      },
    },
  },
}
